import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Frameworks } from "components/Docs/Integrate";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Framework-specific guides that cover our recommended approach to installing PostHog in a number of popular environments.`}</p>
    <Frameworks mdxType="Frameworks" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      